import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7da52113"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-sm text-gray-600 dark:text-white/75 text-left" }
const _hoisted_2 = { class: "w-full flex justify-between items-center font-semibold" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "px-2 opacity-50" }, "—", -1))
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CalendarLtr32Regular = _resolveComponent("CalendarLtr32Regular")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_date_picker = _resolveComponent("n-date-picker")!
  const _component_n_divider = _resolveComponent("n-divider")!
  const _component_n_popover = _resolveComponent("n-popover")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("h4", _hoisted_1, _toDisplayString(_ctx.label), 1),
    _createVNode(_component_n_popover, {
      show: _ctx.show,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.show) = $event)),
      class: "rounded-md",
      placement: "bottom-end",
      trigger: "click"
    }, {
      trigger: _withCtx(() => [
        _createVNode(_component_n_button, {
          secondary: "",
          type: "default",
          class: "rounded-md flex items-center w-full mt-2 px-3",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show = true))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.isSomeRange)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.isSomeRange.label), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("span", null, _toDisplayString(new Date(_ctx.data.value[0]).toISOString().split('T')[0]), 1),
                    _hoisted_5,
                    _createElementVNode("span", null, _toDisplayString(new Date(_ctx.data.value[1]).toISOString().split('T')[0]), 1)
                  ])),
              _createVNode(_component_n_icon, { size: "20" }, {
                default: _withCtx(() => [
                  _createVNode(_component_CalendarLtr32Regular)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("section", null, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ranges, (range, i) => {
              return (_openBlock(), _createBlock(_component_n_button, {
                key: i,
                strong: "",
                size: "tiny",
                class: _normalizeClass(["rounded-md", [i < _ctx.ranges.length - 1 ? 'mr-2' : 'mr-0', _ctx.isSomeRange?.id == range.id ? 'text-white/90' : '']]),
                color: _ctx.isSomeRange?.id == range.id ? _ctx.gl.mainColor : null,
                onClick: ($event: any) => (_ctx.$emit('updateDate', { value: range.value, range: range.id }))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(range.label), 1)
                ]),
                _: 2
              }, 1032, ["class", "color", "onClick"]))
            }), 128))
          ]),
          _createVNode(_component_n_date_picker, {
            panel: "",
            class: "mt-2",
            actions: null,
            type: "daterange",
            size: "large",
            "value-format": "yyyy-MM-dd",
            value: _ctx.data.value,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('updateDate', { value: [$event[0] + 86400000, $event[1] + 86400000] } )))
          }, null, 8, ["value"]),
          _createVNode(_component_n_divider, { class: "my-2" }),
          _createElementVNode("section", _hoisted_7, [
            _createVNode(_component_n_button, {
              secondary: "",
              quaternary: "",
              type: "default",
              class: "rounded-md flex items-center text-main",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.show = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.refs.localization.filters.general.filters_done_label), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}